<template>
	<!-- 填写资料 -->
	<div class="aboutYjBox">
		<!-- 头部 -->
		<van-sticky>
			<div class="headerBox">
				<div class="headerQuery">
					<!-- @click="back" -->
					<div class="arrImg" @click="$router.go(-1)">
						<img src="../../assets/img/leftarr_tit.png" alt="">
					</div>
					<p class="header_titile">填写资料</p>
				</div>
			</div>
		</van-sticky>
		<div class="bottom_bm">
			<span>笔名</span>
			<input type="text" v-model="penName" placeholder="请填写笔名(必填项)">
		</div>
		<div class="tc_login">
			<img src="../../assets/img/flower.png" alt="">
			<button @click="btnUpFn">下一步</button>
		</div>
	</div>
</template>

<script>
	import {Toast} from 'vant';
	export default {
		data() {
			return {
				penName:'',//笔名
			}
		},
		methods: {
			back() {
				this.$router.push('/set')
			},
			btnUpFn(){
				if(this.penName.trim() != ''){
					this.$axios.post(this.$api.be_author,{
						// password:'',//登录密码
						pename:this.penName,//笔名
						// mibao1:'',//密保问题一
						// mibao2:'',//密保问题二
						// mibao3:'',//密保问题三
					}).then(res =>{
						Toast(res.data.msg);
						if(res.data.code == 0){
							return false;
						}else if(res.data.code == 1){
							this.$router.push({path:'/userinfo'})
							localStorage.setItem('autherTxt',res.data.msg)
						}
					})
				}else{
					Toast('请填写笔名')
				}
				
			}
		}
	}
</script>

<style lang="less" scoped>
	.aboutYjBox{
		background-color: #fff;
		height: 100vh;
		overflow-y: scroll;
		color: #000;
		// 头部
		.headerBox {
			height: 160px;
			background-color: #ff4081;
			display: flex;
			background: url(../../assets/img/myicon/indexBgc.png) no-repeat 0% 88% #fff;
			background-size: 100%;
			border-bottom: 1px solid #f0f0f0;/*no*/
			.headerQuery {
				margin-top: 80px;
				padding: 0 16px;
				position: relative;
				display: flex;
				width: 100%;
				height: 80px;
				line-height: 80px;
				color: #000;
		
				.arrImg {
					img {
						width: 40px;
						position: absolute;
						top: 50%;
						transform: translateY(-50%);
						left: 0px;
					}
				}
		
				.header_titile {
					flex: 1;
					text-align: center;
					font-size: 34px;
					/*px*/
				}
			}
		
		}
		.bottom_bm{
			border-bottom: 1px solid #f0f0f0;/*no*/
			line-height: 80px;
			margin: 0 16px;
			display: flex;
			span{
				font-weight: 600;
				font-size: 30px;/*px*/
			}
			input{
				font-size: 28px;/*px*/
				flex:1;
				padding-left: 20px;
			}
		}
		//denglu
		.tc_login {
			text-align: center;
			margin: 400px 0;
			position: relative;
		
			img {
				position: absolute;
				top: -90px;
				right: 15%;
				width: 140px;
			}
		
			button {
				width: 90%;
				background-color: #ff4081;
				color: #fff;
				border: 0;
				line-height: 80px;
				border-radius: 10px;
				font-size: 32px;
				/*px*/
			}
		}
	}

</style>
